// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".subitem__wrapper[data-v-7cb7d481]{position:absolute;top:-1.44928rem}.tabbar__subitem[data-v-7cb7d481]{width:2.41546rem;border:.02415rem solid #d8d8d8;background:#ebe9e9;height:.72464rem;display:-webkit-box;display:-webkit-flex;display:flex;align-items:center;justify-content:center;font-size:.28986rem}.tabbar__subitem span[data-v-7cb7d481]{color:#161616}", ""]);
// Exports
module.exports = exports;
